import { VoicesCampaign } from "../../../Models/voicesCampaigns";

export class VoicesCampaignFormat {
  static date(value: string | null): string {
    return value ? new Date(`${value}T00:00:00`).toLocaleDateString() : "…";
  }

  static period(campaign: VoicesCampaign, noPeriod: string): string {
    if (!campaign.starts_on && !campaign.ends_on) return noPeriod;
    return `${VoicesCampaignFormat.date(campaign.starts_on)} – ${VoicesCampaignFormat.date(
      campaign.ends_on,
    )}`;
  }
}
